import create from "zustand";

import { SearchStoreI } from "@/types";

export const useSearchStore = create<SearchStoreI>()((set) => ({
  searchValue: "",
  setSearchValue: (str: string) => set(() => ({ searchValue: str })),
}));
